<div class="card p-fluid mr-2">
    <div class="flex justify-content-between flex-wrap">
        <div class="flex justify-content-center mb-3">
            <label class="card-heading uppercase" translate>order.lbl_status_and_updates</label>
        </div>
    </div>
    <div class="status-container" style="overflow-y: auto; flex-grow: 1; min-height: 0;">
        <div class="status-inner-container">
            <p-timeline [value]="events" layout="vertical">
                <ng-template pTemplate="marker" let-event>
                    <img class="custom-marker" [ngClass]="event.statusType"
                        [src]="getMarkerImage(event)" alt="status" />
                </ng-template>

                <ng-template pTemplate="content" let-event>
                    <div class="event-content">
                        <div class="event-title"
                            [ngClass]="{'active': event.statusType === 'in-progress', 'upcoming': event.statusType === 'upcoming'}">
                            @if(event.status === 'New Order' && orderStatus === orderStatusConst.BACK_ORDER) {
                            <label translate>lbl_back_order</label>
                            }@else if(event.status === 'New Order' && orderStatus === 'RETURN_ORDER') {
                            <label translate>lbl_return_order</label>
                            } @else if(event.status === eventStatusConst.ORDER_DISPATCHED && orderStatus ===
                            orderStatusConst.AWAITING_ORDER_RECEIVE_CONFIRMATION) {
                            <label translate>lbl_awaiting_order</label>
                            } @else {
                            {{ getDisplayStatus(event) }}
                            }
                        </div>

                        @if (event.statusType !== 'upcoming') {
                        @if ( isOrderConfirmedStatus(event)) {
                        <div class="event-date">
                            <span translate>order.lbl_order_confirmed_date</span>: {{
                            metaDataService.formatDateTimeOnTZ(event.createdAt, 'MMM D, YYYY') }}
                        </div>
                        <div class="event-date">
                            <span translate>order.expected_dispatch_date</span>: {{
                            metaDataService.formatDateTimeOnTZ(attributeValues['date_of_dispatch'], 'MMM D, YYYY') }}
                        </div>
                        } @else if (event.status?.toLowerCase()?.includes('completed')) {
                        <div class="event-date">
                            {{ metaDataService.formatDateTimeOnTZ(event.createdAt, 'MMM D, YYYY') }}
                        </div>
                        } @else if (!event.status?.toLowerCase()?.includes('confirmed')) {
                        <div class="event-date">
                            {{ metaDataService.formatDateTimeOnTZ(event.createdAt, 'MMM D, YYYY') }}
                        </div>
                        } @else {
                        <div class="event-date">
                            Expected Dispatch Date: {{
                            metaDataService.formatDateTimeOnTZ(attributeValues['date_of_dispatch'], 'MMM D, YYYY') }}
                        </div>
                        }
                        }
                    </div>
                </ng-template>
            </p-timeline>

            @if ((orderStatus === 'NEW_ORDER' || orderStatus === 'BACK_ORDER' || orderStatus === 'RETURN_ORDER') &&
            (configService.isTenantAdmin() ||
            configService.isReviewer()) && isStatusUpdate) {
            <div class="flex mt-4 order-btn-actions">
                <button pButton
                    class="flex align-items-center justify-content-center cursor-pointer passenger-box mr-2 nowrap-button"
                    [style.width]="!showPartialOrderButton ? '100%' : ''" (click)="openFullOrderDialog.emit()"
                    translate>lbl_full_order</button>
                @if(showPartialOrderButton){
                <button pButton
                    class="flex align-items-center justify-content-center cursor-pointer passenger-box nowrap-button"
                    (click)="showPartialOrderDialogBoxChange.emit(true)" translate>lbl_partial_order</button>
                }
            </div>
            <div class="mt-2">
                <button pButton
                    class="bg-white justify-content-center default-text-light-black-color cursor-pointer reject-order-btn"
                    (click)="showRejectOrderDialogBoxChange.emit(true)" translate>lbl_reject_order</button>
            </div>
            }
        </div>


    </div>
    @if (orderStatus === 'BACK_ORDER' && configService.isSiteUser()) {
    <div class="mt-2 order-btn-actions">
        <button pButton
            class="justify-content-center default-text-light-black-color cursor-pointer cancel-btn"
            (click)="showRejectOrderDialogBoxChange.emit(true)" translate>lbl_reject_order</button>
    </div>
    }
</div>